module.exports = __webpack_public_path__ + "static/media/location.df62ce92.svg";